export class AppConstant {
  static Languages: any = {
    en: { nativeName: "English" },
    fr: { nativeName: "Français" },
    sw: { nativeName: "Swahili" },
  };

  static DefaultLanguage = "en";

  static DefaultTheme = "light";

  static Logo = "../assets/logo.png";

  static LanguageKeys = Object.keys(this.Languages);

  // static ServerURL = "http://localhost:4000/api/v1/";
  static ServerURL = "https://ogefrem-api.cloudsharx.com/api/v1/";
  static ServiceProvider: string = "Logen Limited";
  static CompanyName: string = "OGEFREM";
  static CurrentYear = new Date().getFullYear();

  static JwtExpired = "jwt expired";

  static supportedFileTypes = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/webp",
    "application/vnd.ms-excel",
    "text/csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  static supportedAttachmentFileTypes = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/webp",
    "application/vnd.ms-excel",
    "text/csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
}
